module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero', {
    attrs: {
      "content": _vm.heroContent
    },
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('voters', {
    staticClass: "voters col-xs-12"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('critic-quote', {
    staticClass: "col-xs-12 no-pad",
    attrs: {
      "criticSliderContent": _vm.criticSlider1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix grid"
  }, [_c('div', {
    staticClass: "cta-wrapper col-xs-12 col-md-6 hideme"
  }, [_c('div', {
    staticClass: "cta hideme"
  }, [_c('div', {
    staticClass: "cta-middle",
    on: {
      "click": _vm.goToUrl
    }
  }, [_vm._v("Listen to score")])])]), _vm._v(" "), _c('production-quote', {
    staticClass: "col-xs-12 col-md-6 no-pad",
    attrs: {
      "id": "bestPictureProdQuote1",
      "prodQuote": _vm.productionQuote1
    }
  })], 1), _vm._v(" "), _c('click-thru', {
    attrs: {
      "clickThru": _vm.clickThru
    },
    on: {
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('legal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95260bd8","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/categoryPages/BestOriginalScore.vue
// module id = 234
// module chunks = 0